export default {
  name: 'Base Theme',
  content: {
    meta: {
      darkMode: false,
    },
    tone: {},
    tokens: {
      colors: {
        $type: 'color',
        foreground: { $value: '#000000' },
        background: { $value: '#ffffff' },
        primary: { $value: '#5c5cff' },
        'primary-contrast': { $value: '#ffffff' },
        utility: {
          backdrop: { $value: '#0000004d' },
          error: { $value: '#d6216b' },
          unselected: { $value: '#627293' },
        },
        dark: {
          foreground: { $value: '#ffffff' },
          background: { $value: '#000000' },
          primary: { $value: '#5c5cff' },
          'primary-contrast': { $value: '#ffffff' },
          utility: {
            backdrop: { $value: '#0000004d' },
            error: { $value: '#bf3c97' },
            unselected: { $value: '#627293' },
          },
        },
      },
      font: {
        family: {
          $type: 'fontFamily',
          base: {
            $value: 'System Sans-serif',
            $extensions: {
              'com.appcues.theme.font': {
                web: {},
                mobile: {
                  ultralight: 'System Default Ultralight',
                  thin: 'System Default Thin',
                  light: 'System Default Light',
                  regular: 'System Default Regular',
                  medium: 'System Default Medium',
                  semibold: 'System Default Semibold',
                  bold: 'System Default Bold',
                  heavy: 'System Default Heavy',
                  black: 'System Default Black',
                },
              },
            },
          },
        },
        weight: {
          $type: 'fontWeight',
          regular: { $value: 'regular' },
          medium: { $value: 'medium' },
          bold: { $value: 'bold' },
        },
        size: {
          $type: 'dimension',
          $extensions: {
            'com.appcues.theme.preset': 'M',
          },
          small: { $value: '14px' },
          regular: { $value: '16px' },
          large: { $value: '22px' },
        },
      },
      dimensions: {
        $type: 'dimension',
        unit: {
          $extensions: {
            'com.appcues.theme.preset': 'M',
          },
          0: { $value: '0px' },
          1: { $value: '8px' },
          2: { $value: '12px' },
          3: { $value: '16px' },
          4: { $value: '20px' },
          5: { $value: '24px' },
        },
      },
      parts: {
        container: {
          'corner-radius': { $type: 'dimension', $value: '8px' },
          padding: { $type: 'dimension', $value: '{dimensions.unit.3}' },
          'shadow-radius': { $type: 'dimension', $value: '6px' },
        },
      },
    },
    components: {
      container: {
        modal: {
          default: {
            $style: {
              backgroundColor: { light: '{colors.background}' },
              cornerRadius: '{parts.container.corner-radius}',
              paddingBottom: '{parts.container.padding}',
              shadow: {
                color: { light: '#00000029' },
                radius: '{parts.container.shadow-radius}',
                x: '0px',
                y: '3px',
              },
            },
            backdrop: {
              $style: {
                backgroundColor: { light: '{colors.utility.backdrop}' },
              },
            },
          },
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: { light: '{colors.background}' },
              cornerRadius: '{parts.container.corner-radius}',
              shadow: {
                color: { light: '#00000029' },
                radius: '{parts.container.shadow-radius}',
                x: '0px',
                y: '3px',
              },
              width: '300px',
            },
            backdrop: {
              $style: {
                backgroundColor: { light: '{colors.utility.backdrop}' },
              },
            },
            pointer: {
              $style: {
                pointerBase: '24px',
                pointerLength: '12px',
              },
            },
          },
        },
        embed: {
          default: {
            $style: {
              backgroundColor: { light: '{colors.background}' },
              paddingBottom: '{parts.container.padding}',
              cornerRadius: '{parts.container.corner-radius}',
            },
          },
        },
      },
      text: {
        default: {
          $style: {
            fontFamily: '{font.family.base}',
            fontWeight: '{font.weight.regular}',
            fontSize: '{font.size.regular}',
            textAlignment: 'center',
            horizontalAlignment: 'center',
            foregroundColor: { light: '{colors.foreground}' },
            marginTop: '{dimensions.unit.1}',
            marginBottom: '{dimensions.unit.1}',
            marginLeading: '{dimensions.unit.3}',
            marginTrailing: '{dimensions.unit.3}',
          },
        },
      },
      button: {
        default: {
          $style: {
            backgroundColor: { light: '{colors.primary}' },
            cornerRadius: '{parts.container.corner-radius}',
            marginTop: '{dimensions.unit.1}',
            marginBottom: '{dimensions.unit.1}',
            marginLeading: '{dimensions.unit.3}',
            marginTrailing: '{dimensions.unit.3}',
            paddingTop: '{dimensions.unit.2}',
            paddingBottom: '{dimensions.unit.2}',
            paddingLeading: '{dimensions.unit.5}',
            paddingTrailing: '{dimensions.unit.5}',
          },
          text: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
              foregroundColor: { light: '{colors.primary-contrast}' },
            },
          },
        },
      },
      hero: {
        default: {
          $style: {
            backgroundColor: { light: '{colors.primary}' },
          },
          title: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.bold}',
              fontSize: '{font.size.large}',
              foregroundColor: { light: '{colors.primary-contrast}' },
              textAlignment: 'center',
              marginTop: '{dimensions.unit.5}',
              marginBottom: '{dimensions.unit.3}',
              marginLeading: '{dimensions.unit.3}',
              marginTrailing: '{dimensions.unit.3}',
            },
          },
          subtitle: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.medium}',
              fontSize: '{font.size.large}',
              foregroundColor: { light: '{colors.primary-contrast}' },
              textAlignment: 'center',
              marginBottom: '{dimensions.unit.5}',
              marginLeading: '{dimensions.unit.3}',
              marginTrailing: '{dimensions.unit.3}',
            },
          },
        },
      },
      image: {
        default: {
          $style: {},
        },
      },
      imagewithtext: {
        default: {
          $style: {
            paddingTop: '{dimensions.unit.1}',
            paddingBottom: '{dimensions.unit.1}',
            paddingLeading: '{dimensions.unit.3}',
            paddingTrailing: '{dimensions.unit.3}',
          },
          image: {
            $style: {
              marginTrailing: '{dimensions.unit.1}',
              width: '56px',
            },
          },
          title: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.bold}',
              fontSize: '{font.size.regular}',
              foregroundColor: { light: '{colors.foreground}' },
              textAlignment: 'leading',
              horizontalAlignment: 'leading',
            },
          },
          subtitle: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
              foregroundColor: { light: '{colors.foreground}' },
              textAlignment: 'leading',
              horizontalAlignment: 'leading',
            },
          },
        },
      },
      select: {
        default: {
          $style: {
            marginBottom: '{dimensions.unit.2}',
            marginLeading: '{dimensions.unit.2}',
            marginTop: '{dimensions.unit.2}',
            marginTrailing: '{dimensions.unit.2}',
          },
          colors: {
            $style: {
              accentColor: { light: '#ffffff' },
              selectedColor: { light: '{colors.foreground}' },
              unselectedColor: { light: '{colors.utility.unselected}' },
            },
          },
          label: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
              foregroundColor: { light: '{colors.foreground}' },
              marginBottom: '{dimensions.unit.2}',
              horizontalAlignment: 'leading',
              textAlignment: 'leading',
            },
          },
          errorLabel: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.small}',
              foregroundColor: { light: '{colors.utility.error}' },
              marginTop: '{dimensions.unit.2}',
              horizontalAlignment: 'leading',
              textAlignment: 'leading',
            },
          },
          optionContent: {
            $style: {
              foregroundColor: { light: '{colors.foreground}' },
              textAlignment: 'leading',
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
            },
          },
          ratingNumberContent: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              foregroundColor: { light: '{colors.primary}' },
              borderColor: { light: '{colors.primary}' },
            },
          },
          ratingNumberContentSelected: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              foregroundColor: { light: '{colors.primary-contrast}' },
              backgroundColor: { light: '{colors.primary}' },
              borderColor: { light: '{colors.primary}' },
            },
          },
          ratingStarContent: {
            $style: {
              foregroundColor: { light: '{colors.primary}' },
            },
          },
          ratingStarContentSelected: {
            $style: {
              foregroundColor: { light: '{colors.primary}' },
            },
          },
          ratingEmojiContent: {
            $style: {
              foregroundColor: { light: '{colors.foreground}' },
            },
          },
          ratingEmojiContentSelected: {
            $style: {
              backgroundColor: { light: '{colors.foreground}' },
              foregroundColor: { light: '{colors.foreground}' },
            },
          },
        },
      },
      textinput: {
        default: {
          $style: {
            marginTop: '{dimensions.unit.2}',
            marginBottom: '{dimensions.unit.2}',
            marginLeading: '{dimensions.unit.3}',
            marginTrailing: '{dimensions.unit.3}',
          },
          label: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
              foregroundColor: { light: '{colors.foreground}' },
              marginBottom: '{dimensions.unit.2}',
              horizontalAlignment: 'leading',
              textAlignment: 'leading',
            },
          },
          errorLabel: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.small}',
              foregroundColor: { light: '{colors.utility.error}' },
              marginTop: '{dimensions.unit.2}',
              horizontalAlignment: 'leading',
              textAlignment: 'leading',
            },
          },
          placeholder: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              foregroundColor: { light: '{colors.utility.unselected}' },
            },
          },
          textField: {
            $style: {
              fontFamily: '{font.family.base}',
              fontWeight: '{font.weight.regular}',
              fontSize: '{font.size.regular}',
              borderColor: { light: '{colors.utility.unselected}' },
              borderWidth: '0.5px',
              cornerRadius: '4px',
              foregroundColor: { light: '{colors.foreground}' },
            },
          },
        },
      },
    },
  },
};
